import { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { GetVisitPdfs } from "Services/API/VisitPdf.service";

export const useVisitPdfs = (visitId, patientId, initialPage = 1, perPage = 10) => {
  const [page, setPage] = useState(initialPage);

  const { data, isLoading, isError, error, refetch } = useQuery(
    ["visitPdfs", visitId, patientId, page],
    () => GetVisitPdfs({ visitId, patientId }, page, perPage),
    {
      enabled: !!visitId && !!patientId,
      keepPreviousData: true,
    },
  );

  const pagination = data?.pagination;

  const goToNextPage = useCallback(() => {
    if (pagination?.hasNext) {
      setPage((prev) => prev + 1);
    }
  }, [pagination?.hasNext]);

  const goToPreviousPage = useCallback(() => {
    if (pagination?.hasPrevious) {
      setPage((prev) => Math.max(prev - 1, 1));
    }
  }, [pagination?.hasPrevious]);

  return {
    pdfs: data?.data || [],
    pagination: data?.pagination || {},
    isLoading,
    isError,
    error,
    page,
    hasNext: pagination?.hasNext ?? false,
    hasPrevious: pagination?.hasPrevious ?? false,
    goToNextPage,
    goToPreviousPage,
    setPage,
    refetch,
  };
};
